import Swal from "sweetalert2";

const swalCustomClass = {
  popup: "pnc-swal-popup",
  icon: "pnc-swal-icone",
  title: "pnc-swal-title",
  htmlContainer: "pnc-swal-texto",
  confirmButton: "pnc-swal-confirmar",
  cancelButton: "pnc-swal-cancelar",
  actions: "pnc-swal-acoes",
};

const MessageBox = {
  success(message, title = "Sucesso") {
    Swal.fire({ position: "top", icon: "success", title, text: message, showConfirmButton: false, timer: 2000 });
  },

  error(message, title = "Erro") {
    Swal.fire({
      position: "top", icon: "error", title, text: message, showConfirmButton: true,
      width: "26rem", customClass: swalCustomClass,
    });
  },

  errorHtml(message, title = "Erro") {
    Swal.fire({
      position: "top", icon: "error", title, html: message, showConfirmButton: true,
      width: "26rem", customClass: swalCustomClass,
    });
  },

  confirm(message, title = "Tem certeza?") {
    return Swal.fire({
      title,
      html: message,
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
      focusCancel: true,
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      width: "26rem",
      customClass: swalCustomClass,
    });
  },

  info(message, title = "InformaÃ§Ã£o") {
    Swal.fire({ position: "top", icon: "info", title, text: message, showConfirmButton: true });
  },

  prompt(message, title = "Informe um valor", inputValue = "") {
    return Swal.fire({
      title, text: message, input: "text", inputValue,
      showCancelButton: true, confirmButtonText: "Confirmar", cancelButtonText: "Cancelar",
      inputValidator: (value) => (!value ? "Campo obrigatÃ³rio." : undefined),
    });
  },

  toastSuccess(message) { toast("success", message); },
  toastError(message) { toast("error", message); },
  toastInfo(message) { toast("info", message); },
};

function toast(icon, message) {
  const Toast = Swal.mixin({
    toast: true,
    position: window.innerWidth <= 768 ? "top" : "top-end",
    showConfirmButton: false,
    timer: 2000,
    timerProgressBar: true,
    didOpen: (el) => {
      el.onmouseenter = Swal.stopTimer;
      el.onmouseleave = Swal.resumeTimer;
    }
  });
  Toast.fire({ icon, title: message });
}

export default MessageBox;
